module.exports = "data:image/png;base64,UklGRrwAAABXRUJQVlA4WAoAAAAQAAAAPwAAPwAAQUxQSB0AAAABD/Bp/4gIoahtI6bMy3zcAnC/iP5PAE555Z/hBABWUDggeAAAABAGAJ0BKkAAQAA+kUCcSqWjoqGkGAtosBIJaQAAC/0Ww8gZLAObGhMmEQXV0yeuJmTNrVUg2dbkIAD++gfqIcpuQUuaYpk3xeYOYTcrGOQ61kz7CrU9yCR0EGp86haY/fTwMxtesdQUeAb4BIGCltV61FinhwAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes/MathNode_body.png
// module id = 22
// module chunks = 0